import { types } from 'mobx-state-tree';

export const InventoryAnalyticsItem = types.model({
  added: types.maybeNull(types.number),
  beverage_id: types.maybeNull(types.number),
  beverages_name: types.maybeNull(types.string),
  container_id: types.maybeNull(types.number),
  containers_name: types.maybeNull(types.string),
  containers_nickname: types.maybeNull(types.string),
  containers_volume_total_ml: types.maybeNull(types.number),
  cooler_id: types.maybeNull(types.number),
  cost: types.maybeNull(types.number),
  ended: types.maybeNull(types.number),
  items_detail: types.maybeNull(types.string),
  pour_cost_pct: types.maybeNull(types.number),
  poured: types.maybeNull(types.number),
  producers_name: types.maybeNull(types.string),
  removed: types.maybeNull(types.number),
  revenue: types.maybeNull(types.number),
  started: types.maybeNull(types.number),
});
